<template>
  <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
    <div class="card">
      <h2 class="card-title">Barcode List</h2>
      <button type="reset" @click="hideprintBarcode" class="btn b-light btn-info-light btn-sm">Products</button>
    </div>
    <button @click="printLabels" class="btn b-light btn-danger-light btn-sm">Print Barcodes</button>
    
    <!-- Printer-specific container -->
  <div id="barcode-container" ref="barcodeContainer"  >
        <div v-for="(product, index) in checkedProducts" 
           :key="index" 
           class="barcode-label">
        <svg :id="'barcode-' + index"></svg>
        <p class="sm-txt_1">{{ product.name }}</p>
        <p class="sm-txt">MTR: {{ product.salerate }} ST.Rate: {{ product.stich_rate }}</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.sm-txt {
  font-size: 14px;
  margin: 2px 0;
}
.sm-txt_1 {
  font-size: 14px;
  margin: 2px 0;
  font-weight: bold;
}
.hide {
    display: none !important;
  }
</style>

<style>
/* Printer-specific styles */
@media print {
  @page {
    size: 1.57in 0.98in; /* Exact label size */
    margin: 0;
  }
  body {
    margin: 0;
    padding: 0;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  .barcode-label {
    width: 1.57in !important;
    height: 0.98in !important;
    text-align: center;
    background: white;
    page-break-after: always;
    margin: 0;
    padding: 2px;
    box-sizing: border-box;
    display: flex !important;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .hide {
    display: none !important;
  }
}
</style>
<script>
import JsBarcode from "jsbarcode";

export default {
  props: {
    GetproductsList: Array
  },
  data() {
    return {
      productsList: this.GetproductsList || [],
    };
  },
  computed: {
    // Only contains checked products (optimized)
    checkedProducts() {
      return this.productsList.filter(product => product.checked === 1);
    }
  },
  methods: {
    hideprintBarcode() {
      this.$emit('hideprintBarcode'); 
    },
    generateBarcodes() {
      // Only process checked products
      this.checkedProducts.forEach((product, index) => {
        setTimeout(() => {
          JsBarcode(`#barcode-${index}`, product.barcode.toString().padStart(5, "0"), {
            format: "CODE128",
            lineColor: "#000",
            width: 2,
            height: 35,
            displayValue: true,
            margin: 5,
          });
        }, 100);
      });
    },
    async printLabels() {
      await this.generateBarcodes();
      
      const printWindow = window.open('', '_blank');
      
      // Use checkedProducts directly (no filtering needed)
      const printContent = this.checkedProducts.map((product, index) => `
        <div class="barcode-label">
          <svg id="print-barcode-${index}"></svg>
          <p class="sm-txt_1">${product.name}</p>
          <p class="sm-txt">MTR: ${product.salerate} ST.Rate: ${product.stich_rate}</p>
        </div>
      `).join('');

      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Barcode Labels</title>
          <style>
            @page { size: 1.57in 0.98in; margin: 0; }
            body { margin: 0; padding: 0; }
            .barcode-label {
              width: 1.57in;
              height: 0.98in;
              text-align: center;
              background: white;
              page-break-after: always;
              margin: 0;
              padding: 2px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            }
            .sm-txt { font-size: 14px; margin: 2px 0; }
            .sm-txt_1 { font-size: 14px; margin: 2px 0; font-weight: bold; }
          </style>
        </head>
        <body>${printContent}</body>
        </html>
      `);
      printWindow.document.close();

      // Generate barcodes in print window
      this.checkedProducts.forEach((product, index) => {
        const element = printWindow.document.getElementById(`print-barcode-${index}`);
        if (element) {
          JsBarcode(element, product.barcode.toString().padStart(5, "0"), {
            format: "CODE128",
            lineColor: "#000",
            width: 2,
            height: 35,
            displayValue: true,
            margin: 5
          });
        }
      });

      setTimeout(() => printWindow.print(), 300);
    }
  },
  mounted() {
    this.generateBarcodes();
  }
};
</script>